<script>
	import ProgressBar from "@okrad/svelte-progressbar";
	export let contestName;
	export let results;
	export let voteFor;

	$: results
		.sort((a, b) => b.votes - a.votes)
		.forEach((candidate, i, candidates) => {
			let previous = candidates[i - 1];

			if (i < voteFor && candidate.votes > 0) {
				candidate.isleader = true;
			} else if (
				previous &&
				previous.isleader &&
				candidate.votes === previous.votes
			) {
				candidate.isleader = true;
			} else {
				candidate.isleader = false;
			}
		});
</script>

	<tr>
		<th colspan="4">{contestName}</th>
	</tr>
	<tr>
		<th class="star visually-hidden">Race Leader</th>
		<th class="candidate-name">Choices</th>
		<th class="votes">Votes</th>
		<th class="percent">Percent</th>
	</tr>
	{#each results as candidate}
		<tr>
			<td class="star" class:leading={candidate.isleader}>
				<span class="visually-hidden">{candidate.isleader ? "Yes" : "No"}</span>
			</td>
			<td class="choice" class:leading={candidate.isleader}>
				{candidate.choiceName}
				{#if candidate.partyBreakdown[0] && candidate.partyBreakdown[0].partyName}
					<i class="electoral-org">{candidate.partyBreakdown[0].partyName}</i>
				{/if}
			</td>
			<td class="votes">
				{candidate.votes}
			</td>
			<td class="percent">
				<ProgressBar
					series={parseFloat(candidate.percentage)}
					width="80"
					valueLabel=" "
					thresholds={[
						{
							till: 100,
							color: candidate.isleader
								? "#017eb5"
								: "#bcdeec",
						},
					]}
				/>
				{candidate.percentage}
			</td>
		</tr>
	{/each}
<style>

	tr:first-of-type th {
		text-align: left;
		border-bottom: 1px solid #ddd;
		padding-top: 2em;
		font-size: 1.25em;
		font-weight: 600;
		color: var(--tableTitleColour);
		letter-spacing: 1px;
	}

	td,
	th {
		padding: .25em 0.75em;
		text-align: left;
		line-height: 1.5em;
	}

	tbody tr td {
		border-top: 1px solid #ddd;
	}

	tbody tr:nth-child(odd) td {
		background-color: #f9f9f9;
	}

	.star {
		text-align: right;
		padding: 0;
	}

	.star.leading::before {
		color: #fdc10c;
		content: "\2605";
		font-size: 1.3em;
	}

	.choice.leading {
		font-weight: 600;
	}

	.votes {
		text-align: right;
	}

	.electoral-org {
		display: block;
		font-style: normal;
		font-weight: 300;
	}

	.visually-hidden {
		clip: rect(0 0 0 0);
		clip-path: inset(50%);
		height: 1px;
		overflow: hidden;
		position: absolute;
		white-space: nowrap;
		width: 1px;
	}
</style>
